
export default {

  state : {
    isLoading : true,
    errors : [],
    pageTitle : ``,
    pageSubtitle : ``,
  },

  mutations : {
    SET_IS_LOADING (state, isLoading = true) {
      state.isLoading = Boolean(isLoading);
    },
    SET_ERRORS (state, errors = []) {
      state.errors = errors;
    },
    SET_PAGE_TITLE (state, title = ``) {
      state.pageTitle = title;
    },
    SET_PAGE_SUBTITLE (state, subtitle = ``) {
      state.pageSubtitle = subtitle;
    },
  },

  actions : {
    isLoading ({ commit }, isLoading) {
      commit(`SET_IS_LOADING`, isLoading);
    },
    setPageTitle ({ commit }, title) {
      commit(`SET_PAGE_TITLE`, title);
    },
    setPageSubtitle ({ commit }, subtitle) {
      commit(`SET_PAGE_SUBTITLE`, subtitle);
    },
    setErrors ({ commit }, errors) {
      commit(`SET_ERRORS`, errors);
    },
    serverError ({ commit, dispatch }, error) {
      dispatch(`isLoading`, false);
      let errorMessage = `Une erreur inconnue s'est produite`;
      if (error.response.status === 404) {
        errorMessage = `Impossible de trouver la ressource demandée`;
      } else if (error.response.data && error.response.status !== 500) {
        errorMessage = error.response.data;
      }
      dispatch(`setErrors`, [errorMessage]);
    },
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/uiState.js